import _isNumber from 'lodash/isNumber';
import _isFinite from 'lodash/isFinite';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
});
const priceFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
export const numberFormatter = (data) => {
  return _isNumber(data) ? Math.floor(data) : 0;
};

export const priceFormatter = (data) => {
  const amount = numberFormatter(data);
  return `${amount >= 0 ? '$' : '-$'}${formatter.format(Math.abs(amount))}`;
};

export const formatNumberToUSD = (data) => {
  return _isFinite(data) ? `${priceFormat.format(data)}` : null;
};
